// Only allow to embed/display websites related to coding within iframe tag
export const AllowedEmbedWebsites  = [
    'codesandbox.io', 
    'codepen.io', 
    'jsfiddle.net', 
    'playcode.io', 
    'jsbin.com', 
    'codeshare.io', 
    'gist.github.com',
    'github.com',
    'githubusercontent.com'
]